import React from "react";
import LeftFiltersAndSort from "./LeftFiltersAndSort";

import "./styles.scss";

export const LeftSide = () => {
	return (
		<div className="left__side__container">
			<LeftFiltersAndSort />
		</div>
	);
};
